import FoodCard from './FoodCard';
import Constants from '../../constants/Constants';

export default class Demo extends FoodCard {
    constructor(props) {
        super(props);

        this.cardSound = Constants.SOUND_DEMO_CARD;
        this.playSoundOn = Constants.CARD_EVENT_ON_AFTER_PLAYER_GET_CARD_FROM_NEW_PILE_OR_USED_PILE;
    }
}
